export default class DolutionLinkProblemDto {
    constructor(obj) {
        this.codeProblem = obj.codeProblem
        this.codeSolution = obj.codeSolution
    }
}
